(() => {
  'use strict';
  if (customElements.get('hh-pdp-benefit-panel')) return;
  const held = new Set(['44641620099357','44641507344669','44641507377437','44641507410205','49903010971933','49903010971901']);
  class BenefitPanel extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.root = this.closest('[data-hh-pdp]');
      this.headline = this.querySelector('[data-hh-pdp-benefit]');
      this.eyebrow = this.querySelector('[data-benefit-eyebrow]');
      this.items = this.querySelector('[data-benefit-items]');
      if (!this.root || !this.headline || !this.items || !this.eyebrow) return;
      this.select = this.root.querySelector('[data-hh-pdp-variant-select]');
      this.icons = this.querySelector('[data-benefit-icon-library]');
      try { this.packs = JSON.parse(this.root.querySelector('[data-hh-pdp-packs]')?.textContent || '{}'); }
      catch { this.packs = {}; }
      this.assignments = [];
      const staged = this.querySelector('[data-benefit-icon-assignments]')?.content.textContent?.trim();
      for (const row of (staged || '').split('|')) {
        const [variant, benefit, values] = row.split('~');
        if (!/^\d+$/.test(variant || '') || held.has(variant) || !benefit || !values) continue;
        this.assignments.push({variant, benefit, items: values.split(';').map(value => {
          const [label, heading, source, target] = value.split('^');
          return {label, heading, source, target};
        })});
      }
      this.sync = this.sync.bind(this);
      this.onChange = () => queueMicrotask(this.sync);
      this.select?.addEventListener('change', this.onChange);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.headline, {childList:true,characterData:true,subtree:true,attributes:true,attributeFilter:['hidden']});
      this.story = this.root.querySelector('[data-hh-pdp-benefits]') || this.root.querySelector('[data-hh-pdp-story]');
      if (this.story) this.observer.observe(this.story, {childList:true,characterData:true,subtree:true});
      this.sync();
    }
    syncStoryIcons(pack, assignment) {
      if (pack?.approved !== true || !assignment || !pack.story?.benefits?.lead) return;
      const section = this.story?.querySelector('.hh-pdp__story-section--benefits');
      if (!section || section.querySelector('.hh-pdp__story-lead')?.textContent !== pack.story.benefits.lead) return;
      const source = pack.story.benefits.items;
      if (!Array.isArray(source) || source.length > 50) return;
      const items = source.filter(item => item && item.heading);
      const rows = Array.from(section.querySelectorAll('.hh-pdp__story-benefit-list > li'));
      if (rows.length !== items.length) return;
      rows.forEach((row, index) => {
        const item = items[index];
        const replacement = assignment.items.find(entry => entry.label === item.label && entry.heading === item.heading && entry.source === item.icon);
        if (!replacement || row.querySelector('h3')?.textContent !== item.heading || row.querySelector('div > span')?.textContent !== (item.label || 'Supports')) return;
        const template = Array.from(this.icons?.content.querySelectorAll('[data-benefit-icon]') || []).find(entry => entry.dataset.benefitIcon === replacement.target);
        const next = template?.content.querySelector('svg');
        const current = row.querySelector(':scope > svg');
        if (current && next && !current.isEqualNode(next)) current.replaceWith(next.cloneNode(true));
      });
    }
    sync() {
      if (!this.isConnected) return;
      const id = String(this.select?.value || this.dataset.initialVariant);
      const pack = this.packs?.[id];
      if (held.has(id)) {
        this.removeAttribute('data-active');
        this.eyebrow.hidden = true;
        this.items.replaceChildren();
        this.items.hidden = true;
        this.signature = '';
        return;
      }
      const text = pack?.approved === true && typeof pack.benefit_line === 'string' ? pack.benefit_line.trim() : '';
      const source = pack?.story?.benefits?.items;
      const items = text && Array.isArray(source) && source.length <= 50 ? source.filter(x => x && typeof (x.heading ?? x.value) === 'string' && (x.heading ?? x.value).trim()) : [];
      const assignment = this.assignments.find(row => row.variant === id && row.benefit === text);
      this.syncStoryIcons(pack, assignment);
      const signature = JSON.stringify([id,text,items,assignment]);
      this.toggleAttribute('data-active', !!text);
      this.eyebrow.hidden = !text;
      if (this.headline.textContent !== text) this.headline.textContent = text;
      if (this.headline.hidden !== !text) this.headline.hidden = !text;
      if (signature === this.signature) return;
      this.signature = signature;
      const fragment = document.createDocumentFragment();
      for (const item of items) {
        const li = document.createElement('li');
        const replacement = assignment?.items.find(row => row.label === item.label && row.heading === (item.heading ?? item.value) && row.source === item.icon);
        const iconKey = replacement?.target || item.icon;
        const icon = Array.from(this.icons?.content.querySelectorAll('[data-benefit-icon]') || []).find(x => x.dataset.benefitIcon === iconKey);
        if (icon) li.appendChild(icon.content.cloneNode(true));
        const words = document.createElement('span');
        if (typeof item.label === 'string' && item.label.trim()) {
          const label = document.createElement('small');
          label.textContent = item.label;
          words.appendChild(label);
        }
        const value = document.createElement('strong');
        value.textContent = item.heading ?? item.value;
        words.appendChild(value);
        li.appendChild(words);
        fragment.appendChild(li);
      }
      this.items.replaceChildren(fragment);
      this.items.hidden = !items.length;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      this.select?.removeEventListener('change', this.onChange);
    }
  }
  customElements.define('hh-pdp-benefit-panel', BenefitPanel);
})();

